(() => {
  const banner = document.getElementById('sowpeace-international-delivery');
  if (!banner || banner.dataset.initialized === 'true') return;
  banner.dataset.initialized = 'true';
  const storageKey = 'sowpeace-delivery-prompt-dismissed';
  banner.querySelector('[data-sp-stay]').addEventListener('click', () => {
    banner.hidden = true;
    try { sessionStorage.setItem(storageKey, 'true'); } catch {}
  });
  if (window.Shopify?.designMode) {
    banner.hidden = false;
    return;
  }
  try { if (sessionStorage.getItem(storageKey) === 'true') return; } catch {}
  const controller = new AbortController();
  const timeout = setTimeout(() => controller.abort(), 3000);
  const root = window.Shopify?.routes?.root || '/';
  fetch(root + 'browsing_context_suggestions.json?country[enabled]=true&language[enabled]=false', { signal: controller.signal })
    .then(response => response.ok ? response.json() : null)
    .then(data => {
      const country = data?.detected_values?.country?.handle;
      if (typeof country === 'string' && /^[A-Z]{2}$/.test(country) && country !== 'IN') banner.hidden = false;
    })
    .catch(() => {})
    .finally(() => clearTimeout(timeout));
})();
